module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Dependant visa","text":{"candidate":"Congratulations!\\nThe Home Office has granted your family member a Dependant visa.","employee":"Congratulations!\\nThe Home Office has granted your family member a Dependant visa."}}}')
  delete Component.options._Ctor
}
